import React from 'react';

export const DocIcon = ({ color = 'currentColor' }) => (
    <svg width="22" height="22" viewBox="0 0 256 256" aria-hidden="true" style={{ flex: '0 0 22px', marginTop: 1 }}>
        <path
            d="M200 224H56a8 8 0 0 1-8-8V40a8 8 0 0 1 8-8h96l56 56v128a8 8 0 0 1-8 8z"
            fill="none"
            stroke={color}
            strokeWidth="14"
            strokeLinejoin="round"
        />
        <polyline points="152 32 152 88 208 88" fill="none" stroke={color} strokeWidth="14" strokeLinejoin="round" />
    </svg>
);
